<template>
    <q-item v-bind="$attrs">
        <q-item-section>
            <q-item-label class="text-uppercase" overline>
                {{ card.brand }}
                <q-chip
                        v-if="label"
                        :label="label"
                        color="primary"
                        text-color="white" square size="sm"
                />
            </q-item-label>
            <q-item-label>{{ card.name }}</q-item-label>
            <q-item-label>xxxx-xxxx-xxxx-{{ card.last4 }}</q-item-label>
            <q-item-label>{{ expires }}</q-item-label>
        </q-item-section>
        <slot />
    </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PaymentMethod, Card } from '@/type';

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export default defineComponent({
  name: 'payment-method-item',
  props: {
    paymentMethod: {
      type: Object as () => PaymentMethod,
      required: true,
    },
  },
  computed: {
    card(): Card {
      return this.paymentMethod.card;
    },
    expires(): string {
      return `${months[this.card.expMonth - 1]}/${this.card.expYear}`;
    },
    label(): string|null {
      return this.paymentMethod.label;
    },
  },
});
</script>
